import { Button, Flex, Heading } from '@chakra-ui/react'
import type { FlexGroupPagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { createContext, useState } from 'react'
import { useNavigate } from 'react-router'

import { Container } from '@/components/Container'
import { Section } from '@/components/Section'
import { FlexGroupList } from '@/containers/flex-group/FlexGroupList'
import { FlexGroupListFilter } from '@/containers/flex-group/FlexGroupListFilter'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { Add } from '@/icons'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'

export const flexGroupListContext = createContext<
  IPaginationContext<FlexGroupPagedQuery>
>({} as IPaginationContext<FlexGroupPagedQuery>)

export const FlexGroupListPage = () => {
  const navigate = useNavigate()

  const [currentPage, setCurrentPage] = useState(1)
  const [filter, setFilter] = useState<FlexGroupPagedQuery>({
    name: '',
    showInvalid: false,
    pageIndex: 1,
    showAllItems: true,
  })

  const { data, refetch, isLoading: isLoading } = useGetAll(filter)
  const items = data?.data

  return (
    <Section>
      <Container>
        <PageContent>
          <flexGroupListContext.Provider
            value={{
              loading: isLoading,
              totalCount: items?.totalCount ?? 0,
              currentPage: currentPage,
              pageSize: 10,
              filter: filter,
              setCurrentPage: setCurrentPage,
              setPageSize: () => { },
              updateFilter: (f) => setFilter(f),
              reload: refetch,
            }}
          >
            <PageToolbar
              leftElements={
                <Flex sx={{ gap: 4, alignItems: 'center' }}>
                  <Heading as="h1">Přehled flexibilních skupin</Heading>
                </Flex>
              }
              rightElements={
                <Flex sx={{ gap: 4 }}>
                  <Button
                    colorScheme="primary"
                    onClick={() => navigate('/flex-group/create')}
                  >
                    <Add />
                    Vytvořit novou flexibilní skupinu
                  </Button>
                </Flex>
              }
            />

            <FlexGroupListFilter />
            <FlexGroupList flexGroups={data?.data.items ?? []} />
          </flexGroupListContext.Provider>
        </PageContent>
      </Container>
    </Section>
  )
}
